// https://www.netlify.com/docs/continuous-deployment/#build-environment-variables
// create-react-app only permits env variables prefixed with REACT_APP
// so we alias netlify's env variables here: apps/members/package.json `build` command
export const commitSHA = process.env.REACT_APP_COMMIT_REF;
